function extractModulesProperty(items, key) {
  return items.filter(item => item[key]).map(item => item[key]);
}
function getModuleDucks(modules) {
  return extractModulesProperty(modules, 'duck');
}
function getModuleCtxMiddleware(modules) {
  // extract and create each modules ctxMiddleware creator
  const extractedCtxMiddleware = extractModulesProperty(modules, 'ctxMiddleware').map(fn => fn());
  return ({
    fetchCompositeJSON = true,
    batchDispatch = true
  } = {}) => [...extractedCtxMiddleware, async ctx => {
    // optionally allow the generate composite fetch to be processed after middleware is run
    if (fetchCompositeJSON) {
      // fetch the composite request
      const fetchResponse = await ctx.fetchCompositeJSON.fetchComposite();

      // assign the fetch response to the data object in ctx
      Object.assign(ctx.data, fetchResponse);
    }

    // optionally allow the generated batch dispatch to be processed after middleware is run
    if (batchDispatch) {
      await ctx.batchDispatch.dispatchActions();
    }
  }];
}

export { extractModulesProperty, getModuleCtxMiddleware, getModuleDucks };
